import { render, staticRenderFns } from "./Part2ReplyEmail.vue?vue&type=template&id=ef7741a4&scoped=true"
import script from "./Part2ReplyEmail.vue?vue&type=script&lang=js"
export * from "./Part2ReplyEmail.vue?vue&type=script&lang=js"
import style0 from "./Part2ReplyEmail.vue?vue&type=style&index=0&id=ef7741a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7741a4",
  null
  
)

export default component.exports